<template>
  <div class="margin">

    <div class="container d-flex align-center flex-column padding">
      <div class="faq-details">
        <h1 data-aos="slide-left" data-aos-duration="10000">
          Documentacíon
        </h1>
        <p data-aos="slide-right" data-aos-duration="10000">
          Aprende paso a paso
        </p>
      </div>
      <div class="accordion-list" v-if="docs.length>=0" data-aos="slide-up" data-aos-duration="10000">
        <div v-for="(doc, index) in docs"  :key="doc.id">
          <AccordionComponent>
            <h1 slot="accordion-heading">
              {{ index+1+".- "+doc.title}}
            </h1>
            <div slot="accordion-text">
              <div>
                <p>
                  {{doc.description}}
                </p>
              </div>
              <div class="doc-image-ctner">
                <img  class="doc-image"  :src="getImgUrl(doc.id)" v-bind:alt="pic">
              </div>
              <br>
            </div>
          </AccordionComponent>
        </div>




      </div>

      <div v-if="xhrRequest" class="spinner-border text-secondary loader" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>
<script>
import AccordionComponent from "./AccordionComponent";
import axios from "axios";
import constants from "@/utils/constants";

export default {
  components: {
    AccordionComponent
  },
  data() {
    return {
      xhrRequest: false,
      docs:[],
    }
  },
  methods:{
    getImgUrl(pic) {

      return require("../../assets/images/"+pic+".png");
    },
    getDocs: function() {
      axios.get(constants.endpointList.docs,
      ).then((result)=>{
        this.docs=result.data;
        console.log(result);
      }).catch((error)=>{
        console.log(error);
      });

    },
  },
  created: function(){
    this.getDocs();
  }
};
</script>
<style scoped>
.doc-image{
  width: 90%;
  height: 100%;
}
.doc-image-ctner{
text-align:center;
}
</style>
